import { Component, OnInit, OnDestroy } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from 'src/environments/environment';
import { HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from './services/auth.service';
import { ChangeDetectorRef } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  userActivity;
  userInactive: Subject<any> = new Subject();

  setTimeout() {
    const timeOutPeriod = (60 * 1000) * 120;  // Converting to 120 Minutes to Milliseconds
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), timeOutPeriod);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  title = 'CRM | Apollo Health & Lifestyle Limited (AHLL) - Apollo Clinics';

  // routerSub: Subscription

  constructor(
    private authService: AuthService,
    private changesDetectRef: ChangeDetectorRef,
    // private socket: Socket
    private router: Router,
    //  private socket: Socket
  ) {
    this.setTimeout();
    this.userInactive.subscribe(() => this.logOut());
    // this.socket.connect(); 
  }

  logOut() {    
    localStorage.clear();
    localStorage.removeItem("CurrentInBoundCallDetails")
    this.authService.removeTokens();
    this.changesDetectRef.detectChanges();
    this.router.navigate(['/auth/login']);
  }

  ngOnInit() {
    if (environment.forceHttps) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // hide splash screen

        // scroll to top on every route change
        window.scrollTo(0, 0);

      }
    });


  }

  onSubmit(ev) {
    // this.socket.emit('agentJoin', { agentId: ev.value }, (error) => {
    //   if (error) {
    //     alert(error.error)
    //   }
    // })
  }

  ngAfterViewInit() {
    // this.socket.emit('agentJoin', { agentId: '9542385668' }, (error) => {
    //   if (error) {
    //     alert(error.error)
    //   }
    // });

    // this.socket.on('receiveCall', (data) => {
    //   console.log(data);
    //   console.log("call recieved")
    // })
  }

  ngOnDestroy() {
    // this.routerSub.unsubscribe();
  }

}
